import { render, staticRenderFns } from "./JsonKey.vue?vue&type=template&id=23108eaf&scoped=true&"
import script from "./JsonKey.vue?vue&type=script&lang=js&"
export * from "./JsonKey.vue?vue&type=script&lang=js&"
import style0 from "./JsonKey.vue?vue&type=style&index=0&id=23108eaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23108eaf",
  null
  
)

export default component.exports